module.exports = __webpack_public_path__ + "img/2021_SA_ICONS-51.png";